import { render, staticRenderFns } from "./example3.vue?vue&type=template&id=3a034805&lang=html&"
import script from "./example3.vue?vue&type=script&lang=js&"
export * from "./example3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "example3.vue"
export default component.exports